/** BCP 47 tag for G1 wall date/time (admin `ptBR` / `en`, browser, or explicit tag). */
export function resolveG1WallLocaleTag(locale?: string): string {
  if (!locale?.trim()) {
    return typeof navigator !== 'undefined' ? navigator.language : 'pt-BR'
  }
  const normalized = locale.trim()
  if (normalized === 'ptBR') {
    return 'pt-BR'
  }
  if (normalized === 'en') {
    return 'en-US'
  }
  return normalized
}

const G1_WALL_HEADER_TIME_OPTS: Intl.DateTimeFormatOptions = {
  hour: '2-digit',
  minute: '2-digit'
}

/** Localized time for the G1 header (e.g. pt-BR `20:01`). */
export function formatG1WallHeaderDateTime(date: Date = new Date(), locale?: string): string {
  const tag = resolveG1WallLocaleTag(locale)
  return date.toLocaleTimeString(tag, G1_WALL_HEADER_TIME_OPTS)
}

/** Tick the header clock; returns a dispose function. */
export function startG1WallClock(
  setLabel: (label: string) => void,
  options?: {
    getLocale?: () => string | undefined
    intervalMs?: number
  }
): () => void {
  const intervalMs = options?.intervalMs ?? 30_000
  const tick = () => {
    setLabel(formatG1WallHeaderDateTime(new Date(), options?.getLocale?.()))
  }
  tick()
  const id = setInterval(tick, intervalMs)
  return () => clearInterval(id)
}
